import commoncss from '../css/common.module.css';
import buttoncss from "../css/button.module.css";


export function Button({ class_="" , label, icon,btnColor, isEnabled=true,onClick, type="button", ...rest }) {
  
  return (
    <button type={type} className={`${buttoncss.custom_btn} ${btnColor === buttoncss.secondary ? buttoncss.secondary : btnColor}  ${isEnabled === true ? 'clickable' : commoncss.cursorNA} ${class_} `} disabled={!isEnabled} onClick={onClick} {...rest}>
      {icon && (icon)} {label}
    </button>
  );
}

export function FilterButton({ class_="" ,active, label, icon,btnColor="", isEnabled=true,onClick, ...rest }) {
  return (
    <button className={`${buttoncss.custom_btn} ${active ? buttoncss.filterBtnActive : buttoncss.filterBtnInactive} ${class_} ${isEnabled === true ? 'clickable' : ''}`} disabled={!isEnabled} onClick={onClick} {...rest}>
      {icon && (icon)} {label}
    </button>
  );
}

export function TableButton({ class_="" ,active, label, icon,btnColor="", isEnabled=true,onClick, ...rest }) {
  return (
    <button className={`${class_} ${buttoncss.custom_btn} ${buttoncss.tableButton} ${commoncss.w100} ${active ? buttoncss.tableButton : buttoncss.filterBtnInactive}  ${isEnabled === true ? 'clickable' : ''}`} disabled={!isEnabled} onClick={onClick} {...rest}>
      {icon && (icon)} {label}
    </button>
  );
}


export function IconButton({ class_="" , label, icon,btnColor, isEnabled=true,onClick, ...rest }) {
  return (
    <button className={`${class_} ${buttoncss.custom_btn} ${btnColor === buttoncss.secondary ? buttoncss.secondary : btnColor} ${buttoncss.buttonIcon}  ${isEnabled === true ? 'clickable' : ''}`} disabled={!isEnabled} onClick={onClick} {...rest}>
      <span className={buttoncss.iconSpan}>{icon && (icon)}</span><span className={commoncss.labelBlack}>{label}</span>
    </button>
  );
}
